import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PageLoader from "../loader/PageLoader";
import SuperAdminRoutes from "./private/SuperAdminRoutes";
// import { SimulationProvider } from "../context/SimulationContext";
import CustomTheme from "../Theme/Theme";
export const baseUrl = "/retail";

const PageNotFound = lazy(() => import("../error/PageNotFound"));
const AdminRoutes = lazy(() => import("./private/AdminRoutes"));
const StudentRoutes = lazy(() => import("./private/StudentRoutes"));
const PublicRoutes = lazy(() => import("./PublicRoutes"));

const AppRoutes = () => {
  return (
    <>
      <CustomTheme>
        <BrowserRouter basename={baseUrl}>
          {/* <SimulationProvider> */}{" "}
          <Suspense fallback={<PageLoader />}>
            <Routes>
              {/* public routes  */}
              <Route path="/*" element={<PublicRoutes />} />

              {/* protected routes  */}
              <Route path="/admin/*" element={<AdminRoutes />} />
              <Route path="/superAdmin/*" element={<SuperAdminRoutes />} />
              <Route path="/student/*" element={<StudentRoutes />} />

              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
          {/* </SimulationProvider> */}
        </BrowserRouter>
      </CustomTheme>
    </>
  );
};

export default AppRoutes;
